import { __rest, __assign } from 'tslib';
import React from 'react';
import { faDoNotEnter, faCheckCircle } from '@fortawesome/pro-solid-svg-icons';
import { classNames } from '../../utils/classNames/classNames.esm.js';
import '@popperjs/core';
import '../Icon/ImgIcon.esm.js';
import { FaIcon } from '../Icon/FaIcon.esm.js';
import '../Icon/SemanticIcons.esm.js';

var Handle = function (_a) {
    var checked = _a.checked, passThrough = __rest(_a, ["checked"]);
    return (React.createElement("span", __assign({ className: classNames("tw-pointer-events-none tw-text-dark-bg dark:tw-text-default tw-rounded-full tw-w-3 tw-h-3 tw-shadow tw-inline-block", "tw-transition tw-transform tw-duration-200 tw-ease-in-out", checked ? "tw-translate-x-4" : "tw-translate-x-0"), "aria-hidden": "true" }, passThrough),
        React.createElement("span", { className: classNames("tw-absolute tw-inset-0 tw-h-full tw-w-full tw-flex tw-items-center tw-justify-center tw-transition-opacity", checked
                ? "tw-opacity-0 tw-ease-out tw-duration-100"
                : "tw-opacity-100 tw-ease-in tw-duration-200") },
            React.createElement(FaIcon, { faIconDef: faDoNotEnter, style: { height: "100%", width: "100%" } })),
        React.createElement("span", { className: classNames("tw-absolute tw-inset-0 tw-h-full tw-w-full tw-flex tw-items-center tw-justify-center tw-transition-opacity", checked
                ? "tw-opacity-100 tw-ease-in tw-duration-200"
                : "tw-opacity-0 tw-ease-out tw-duration-100") },
            React.createElement(FaIcon, { faIconDef: faCheckCircle, style: { height: "100%", width: "100%" } }))));
};

export { Handle };
//# sourceMappingURL=Handle.esm.js.map
